var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n  "+_vm._s(_vm.address.title)+" "+_vm._s(_vm.address.firstname)+" "+_vm._s(_vm.address.lastname)),_c('br'),_vm._v("\n  "+_vm._s(_vm.address.address)),_c('br'),_vm._v("\n  "+_vm._s(_vm.address.zip)+" "+_vm._s(_vm.address.city)),_c('br'),_vm._v("\n  "+_vm._s(_vm.address.country)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-122c13c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserAddress.vue
// module id = null
// module chunks = 